// extracted by mini-css-extract-plugin
module.exports = {"login-page":"login-page--3zfEq","loginPage":"login-page--3zfEq"};